import { DatePipe, Location } from '@angular/common';
import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';

import { MensagemDetalhesBuscaModel } from '../../../../shared/model/chat/mensagens/mensagem-detalhes-busca.model';
import { MensagemDetalhesModel } from '../../../../shared/model/chat/mensagens/mensagem-detalhes.model';
import { CelularMaskPipe } from '../../../../shared/pipe/celular-mask.pipe';
import { AvatarPessoaComponent } from '../../../../shared/components/redesign/avatar-pessoa/avatar-pessoa.component';
import { AuthService } from '../../../../shared/service/auth.service';
import { MensagemService } from '../../../../shared/service/mensagens.service';
import { ModalInfoMensagemData } from './models/modal-info-mensagem-data.model';
import { ArrastarFecharSheetDirective } from '../../../utils/arrastar-fechar-sheet.directive';

@Component({
  selector: 'app-modal-info-mensagem',
  standalone: true,
  imports: [
    DatePipe,
    MatIcon,
    MatTooltip,
    CelularMaskPipe,
    ArrastarFecharSheetDirective,
    AvatarPessoaComponent
  ],
  templateUrl: './modal-info-mensagem.component.html',
  styleUrl: './modal-info-mensagem.component.css'
})
export class ModalInfoMensagemComponent implements OnInit {
  private readonly data = inject<ModalInfoMensagemData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ModalInfoMensagemComponent>);
  private readonly mensagemService = inject(MensagemService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  private readonly acessoDisparos = this.authService.possuiAcessoRotina('disparos');
  private readonly acessoTemplates = this.authService.possuiAcessoRotina('template');

  readonly mensagem = this.data.mensagem;
  readonly ehDisparo = this.data.tipo === 1;

  carregando = signal(true);
  detalhes = signal<MensagemDetalhesModel>(new MensagemDetalhesModel());

  readonly linkDisparo = computed(() => {
    const uuid = this.detalhes().disparo?.uuid;
    return this.acessoDisparos && uuid ? this.montarLink('/disparos', { uuid }) : null;
  });

  readonly linkTemplate = computed(() => {
    const nome = this.detalhes().template?.nome;
    return this.acessoTemplates && nome ? this.montarLink('/template', { busca: nome }) : null;
  });

  ngOnInit(): void {
    const busca = new MensagemDetalhesBuscaModel();
    busca.idMsg = this.mensagem.id;
    busca.contato = this.data.contato;
    busca.dataEnvio = this.mensagem.date;
    busca.idTemplateMeta = this.mensagem.idTemplateMeta;
    busca.idUsuarioEnvio = this.mensagem.idUsuarioEnvio;

    this.mensagemService.buscarDetalhesMensagemPorId(busca).subscribe({
      next: res => this.detalhes.set(res ?? new MensagemDetalhesModel()),
      error: () => this.carregando.set(false),
      complete: () => this.carregando.set(false)
    });
  }

  rotuloIdNome(id?: number, nome?: string): string {
    if (!id) {
      return '-';
    }
    return nome ? `${id} - ${nome}` : `${id}`;
  }

  abrirEmNovaAba(link: string | null): void {
    if (link) {
      window.open(link, '_blank', 'noopener');
    }
  }

  fechar(): void {
    this.dialogRef.close();
  }

  private montarLink(rota: string, queryParams: Record<string, string>): string {
    const url = this.router.serializeUrl(this.router.createUrlTree([rota], { queryParams }));
    return this.location.prepareExternalUrl(url);
  }
}
